package meineglasfaser.frontend.www.pages.portal.auth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import meineglasfaser.api.routes.AuthRoutes.RealmCustomerPortal.ForgotStage1
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.ErrorCard
import meineglasfaser.frontend.common.components.widgets.Toast
import meineglasfaser.frontend.common.components.widgets.Toasts
import meineglasfaser.frontend.common.components.yaform.YaForm
import meineglasfaser.frontend.common.components.yaform.YaFormButton
import meineglasfaser.frontend.common.components.yaform.YaFormTextInput
import meineglasfaser.frontend.common.setJsonBody
import meineglasfaser.frontend.common.withAuth
import meineglasfaser.frontend.www.components.CustomerState
import meineglasfaser.frontend.www.components.CustomerStateRedirectIfLoggedIn
import meineglasfaser.frontend.www.components.GlobalCustomerState
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.*

private enum class Stage1State {
    ENTER_EMAIL,
    REQUESTED,
}

@Page("forgot/stage1")
@Layout(".components.layouts.ShopLayout")
@Composable
fun ForgotPage() {
    CustomerStateRedirectIfLoggedIn()
    var state by remember { mutableStateOf(Stage1State.ENTER_EMAIL) }
    var errorText by remember { mutableStateOf<String?>(null) }

    Div(attrs = { classes("auth-form")}) {
        H1(attrs = { classes("text-center") }) {
            Text("Passwort vergessen?")
        }
        YaForm(
            onSubmitScope = { data ->
                val body = ForgotStage1.RequestBody(
                    email = data.string(ForgotStage1.RequestBody::email)
                )
                BackendApi.post(ForgotStage1()) {
                    withAuth()
                    setJsonBody(body)
                }.fold(
                    onSuccess = {
                        GlobalCustomerState.value = CustomerState.LoggedOut
                        state = Stage1State.REQUESTED
                        errorText = null
                    },
                    onFailure = { error ->
                        errorText = "Ein Fehler ist aufgetreten"
                    }
                )
            }
        ) {
            when (state) {
                Stage1State.ENTER_EMAIL -> {
                    P(attrs = { classes("text-center") }) {
                        Span { Text("Geben Sie hier die E-Mail Ihres Benutzerkontos ein, und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.") }
                    }
                    YaFormTextInput(
                        prop = ForgotStage1.RequestBody::email,
                        label = { Text("E-Mail") },
                        type = InputType.Email,
                        required = true,
                    )
                    YaFormButton(ButtonType.Submit) {
                        Text("Anfordern")
                    }
                }
                Stage1State.REQUESTED -> {
                    P(attrs = { classes("text-center") }) {
                        Span {
                            Text("Rücksetzung angefordert. Bitte überprüfen Sie Ihr Postfach.")
                        }
                    }
                }
            }
        }
        ErrorCard(errorText)
    }
}
